import {observer} from "mobx-react";
import * as React from "react";
import {createRef} from "react";
import {NavAvatar} from "../../nav/NavAvatar";
import {Modal} from "../../widgets/modal/Modal";
import {computed} from "mobx";
import {CommentBlock} from "./CommentBlock";
import FullPostModalData from "../../../data/FullPostModalData";

import './FullPostModal.pcss';
import {UIState} from "../../../data/UIState";
import {UIStateVendor} from "../../../data/UIStateVendor";
import {HeaderLevelCorrectedContent} from "components/feed/FeedItem/HeaderLevelCorrectedContent";

interface Props { }

@observer
export class FullPostModal extends React.Component<Props> {

  // h1Ref;
  //
  // constructor(props) {
  //   super(props);
  //   this.h1Ref = createRef()
  // }
  //
  // componentDidMount() {
  //   console.log("componentDidMount FullPostModal");
  //   if(this.h1Ref && this.h1Ref.current) {
  //     console.log("componentDidMount FullPostModal > setting focus");
  //     this.h1Ref.current.focus();
  //   }
  // }

  @computed get authorName() {
    return FullPostModalData.author ? FullPostModalData.author.firstName + " " + FullPostModalData.author.lastName : "Wellness Concepts";
  }

  @computed get showFeedItemCommenting() {
    return FullPostModalData.post.commenting && FullPostModalData.feedItem;
  }

  @computed get showPostCommenting() {
    return FullPostModalData.post.commenting && !FullPostModalData.feedItem;
  }

  @computed get commentsAreLoaded() {
    return null!=FullPostModalData.comments;
  }

  @computed get commentPeriodHasEnded() {
    return UIState.feedData && UIState.feedData.solution ? UIState.feedData.solution.commentPeriodHasEnded : false;
  }

  @computed get user() {
    return UIState.user ? UIState.user : UIStateVendor.user;
  }

  render() {
    const props = FullPostModalData;
    return (
      <Modal
        closeModal={FullPostModalData.closeFullPostModal}
        title={FullPostModalData.post.title}
        user={FullPostModalData.author}
      >
        <div className="modalContent feedItem full-post-modal">
          {(UIState.isMobile && FullPostModalData.author) &&
              <div className="fpm-topper">
                {FullPostModalData.author && <div className="fpm-topper-avatar"><NavAvatar user={FullPostModalData.author} variant={'boxy'} /></div>}
                <div className={`fpm-topper-title`}>
                  <h2 className={'level2'}>
                    <span className="material-icons verified" aria-hidden="true">verified</span>
                    <span className="name">{FullPostModalData.author.firstName} {FullPostModalData.author.lastName}</span>
                    {FullPostModalData.author.professionalTitle && <span><br/>{FullPostModalData.author.professionalTitle}</span>}
                  </h2>
                </div>
              </div>   }
          <HeaderLevelCorrectedContent className="fullPost" content={FullPostModalData.post.fullPost} offset={'full-post'} />
        </div>
        {FullPostModalData.post.commenting && FullPostModalData.commentsLoadedSuccessfully &&
          <CommentBlock
              comments={FullPostModalData.comments }
              addComment={FullPostModalData.addComment}
              commentPeriodHasEnded={this.commentPeriodHasEnded}
              user={this.user}
              postAuthor={FullPostModalData.author}
              post={FullPostModalData.post}
          />
        }
      </Modal>
    );
  }

}
